/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class VendorListMetadata extends JSONable {
  totalSize: number | undefined = undefined;
  vendorName: string | undefined = undefined;
  businessProfile: string | undefined = undefined;
  addressTypes: string[] | undefined = undefined;
}
